// extracted by mini-css-extract-plugin
export var defaultWrapper = "_io-3";
export var downloadButton = "_io-4";
export var fileContainer = "_io-9 _io-7";
export var fileContainerBase = "_io-7";
export var fileContainerFixedHeight = "_io-8 _io-7";
export var fileInfo = "_io-5";
export var fileInfoWidthRestricted = "_io-6";
export var fileType = "_io-1";
export var fileTypeName = "_io-2";
export var image = "_io-0";
export var link = "_io-b";
export var overflowEllipsis = "_io-a";